// src/features/media/components/MediaStatusBadge.tsx

import { Badge } from '@mantine/core';
import { MediaStatusType, MediaStateType } from '@lib2/model/media/MediaTypes';
import { MEDIA_STATUS_LABELS, MEDIA_STATUS_COLORS } from '@/lib/constants/media';

interface MediaStatusBadgeProps {
  status: MediaStatusType;
  state: MediaStateType;
}

export function MediaStatusBadge({ status, state }: MediaStatusBadgeProps) {
  // For ready videos, show active/inactive state
  if (status === MediaStatusType.Ready) {
    const isActive = state === MediaStateType.Active;
    return (
      <Badge
        color={isActive ? 'green' : 'gray'}
        variant="light"
        size="sm"
      >
        {isActive ? 'Active' : 'Inactive'}
      </Badge>
    );
  }

  // For non-ready videos, show processing status
  return (
    <Badge
      color={MEDIA_STATUS_COLORS[status]}
      variant="light"
      size="sm"
    >
      {MEDIA_STATUS_LABELS[status]}
    </Badge>
  );
}
